<template>
  <form v-on:keyup.enter="submit">
    <v-layout pt-2 pl-2 row wrap>
      <v-flex xs12 md12 lg5 xl5 class="rounded-container" pb-2>
        <v-layout
          v-if="bookingForm != null && bookingForm.booking != null"
          class="small-book-form"
          column
          align-content-start
        >
          <v-flex>
            <v-layout pt-2 row wrap>
              <v-flex shrink>
                <CustomerSearchInput :bookingForm="bookingForm" :updateMode="updateMode" />
              </v-flex>
              <v-flex shrink>
                <BookingDateTimeInput :bookingForm="bookingForm" :hideAsapToggle="backdate" />
              </v-flex>
            </v-layout>
            <v-flex>
              <BusinessCustomerDetailsInput :bookingForm="bookingForm" />
            </v-flex>
            <v-flex pb-2 px-2>
              <v-divider></v-divider>
            </v-flex>
            <v-layout px-1 row wrap align-start>
              <v-flex md4>
                <BookingLocationInput
                  flatField
                  @locationChanged="pickupUpdated"
                  v-model="bookingForm.booking.pickup_location"
                  label="Pickup Location"
                  id="pickup_lg"
                  :error="bookingForm.errors.pickup_location"
                />
              </v-flex>
              <v-icon
                style="padding-left: 4px;"
                v-if="!pickupInfoActive()"
                class="add-person-button"
                v-on:click="function(){activatePickupInfo()}"
              >person_add</v-icon>
              <v-flex px-1 xs6 md2>
                <SimpleTextInput
                  v-if="pickupInfoActive()"
                  v-model="bookingForm.booking.pickup_info.name"
                  label="Name"
                  :error="bookingForm.errors.pickup_info"
                />
              </v-flex>
              <v-flex px-1 shrink v-if="pickupInfoActive()">
                <v-row>
                  <v-flex shrink>
                    <SimpleTextInput
                      v-model="bookingForm.booking.pickup_info.contact_number"
                      width="120px"
                      label="Contact No."
                    />
                  </v-flex>
                  <v-flex shrink v-if="bookingForm.booking.state != null">
                    <a
                      :href="'tel:' + formatNumber(bookingForm.booking.pickup_info.contact_number)"
                    >
                      <v-btn class="small-fab-phone" icon flat="flat" @click="addingCard = false">
                        <v-icon>phone</v-icon>
                      </v-btn>
                    </a>
                  </v-flex>
                </v-row>
              </v-flex>
              <v-flex>
                <SimpleTextInput
                  v-if="pickupInfoActive()"
                  v-model="bookingForm.booking.pickup_info.notes"
                  label="Notes"
                  :maxlength="300"
                />
              </v-flex>
              <v-btn
                v-if="pickupInfoActive()"
                class="small-fab-phone visibility-toggle"
                icon
                flat="flat"
                @click="bookingForm.booking.pickup_info.active = false"
              >
                <v-icon>visibility_off</v-icon>
              </v-btn>
            </v-layout>
            <v-layout pl-1 pr-1 pt-1 row wrap align-start justify-start>
              <v-flex xs12 v-for="(destination, index) in bookingForm.booking.destinations">
                <v-layout py-1 align-start row wrap v-if="index > 0">
                  <v-flex xs11 md4>
                    <BookingLocationInput
                      flatField
                      :removable="true"
                      @locationChanged="viaUpdated"
                      v-model="bookingForm.booking.destinations[index]"
                      :id="'destination_lg'+index"
                      :deletable="index > 0"
                      @removePressed="function(){removeVia(index)}"
                      :label="index == 0 ? 'Destination' : 'Via ' + index "
                      :error="bookingForm.errors[`destination_${index}`]"
                    />
                  </v-flex>
                  <v-icon
                    v-if="!viaActive(bookingForm.booking.via_info[index-1])"
                    class="add-person-button"
                    v-on:click="function(){activateViaInfo(index)}"
                  >person_add</v-icon>
                  <v-flex px-1 v-if="viaActive(bookingForm.booking.via_info[index-1])" xs6 md2>
                    <SimpleTextInput
                      v-model="bookingForm.booking.via_info[index-1].name"
                      label="Name"
                      :error="bookingForm.errors[`via_info_${index-1}`]"
                    />
                  </v-flex>
                  <v-flex pl-1 v-if="viaActive(bookingForm.booking.via_info[index-1])" shrink>
                    <v-row>
                      <v-flex shrink>
                        <SimpleTextInput
                          v-model="bookingForm.booking.via_info[index-1].contact_number"
                          label="Contact No."
                          width="120px"
                        />
                      </v-flex>
                      <v-flex shrink v-if="bookingForm.booking.state != null">
                        <a
                          :href="'tel:' + formatNumber(bookingForm.booking.via_info[index-1].contact_number)"
                        >
                          <v-btn
                            class="small-fab-phone"
                            icon
                            flat="flat"
                            @click="addingCard = false"
                          >
                            <v-icon>phone</v-icon>
                          </v-btn>
                        </a>
                      </v-flex>
                    </v-row>
                  </v-flex>
                  <v-flex v-if="viaActive(bookingForm.booking.via_info[index-1])">
                    <SimpleTextInput
                      v-model="bookingForm.booking.via_info[index-1].notes"
                      label="Notes"
                      :maxlength="300"
                    />
                  </v-flex>
                  <v-btn
                    v-if="viaActive(bookingForm.booking.via_info[index-1])"
                    class="small-fab-phone visibility-toggle"
                    icon
                    flat="flat"
                    @click="bookingForm.booking.via_info[index-1].active = false"
                  >
                    <v-icon>visibility_off</v-icon>
                  </v-btn>
                </v-layout>
              </v-flex>
            </v-layout>
            <v-layout px-1 row wrap align-start>
              <v-flex md4>
                <v-row>
                  <v-flex shrink pt-2>
                    <v-icon
                      style="padding-left: 4px; padding-right: 4px;"
                      @click="swapPickupAndDestination()"
                    >swap_horiz</v-icon>
                  </v-flex>
                  <v-flex pt-1>
                    <BookingLocationInput
                      flatField
                      @locationChanged="destinationUpdated"
                      v-model="bookingForm.booking.destinations[0]"
                      label="Destination Location"
                      id="destination_lg"
                      :error="bookingForm.errors['destination_0']"
                    />
                  </v-flex>
                </v-row>
              </v-flex>
              <v-flex pt-1 v-if="!destinationInfoActive()">
                <v-icon
                  style="padding-left: 4px;"
                  class="add-person-button"
                  v-on:click="function(){activateDestinationInfo()}"
                >person_add</v-icon>
              </v-flex>
              <v-flex px-1 v-if="destinationInfoActive()" xs6 md2 pt-1>
                <SimpleTextInput
                  v-model="bookingForm.booking.destination_info.name"
                  label="Name"
                  :error="bookingForm.errors.destination_info"
                />
              </v-flex>
              <v-flex pl-1 v-if="destinationInfoActive()" pt-1 shrink>
                <v-row>
                  <v-flex>
                    <SimpleTextInput
                      v-model="bookingForm.booking.destination_info.contact_number"
                      width="120px"
                      label="Contact No."
                    />
                  </v-flex>
                  <v-flex shrink v-if="bookingForm.booking.state != null">
                    <a
                      :href="'tel:' + formatNumber(bookingForm.booking.destination_info.contact_number)"
                    >
                      <v-btn class="small-fab-phone" icon flat="flat" @click="addingCard = false">
                        <v-icon>phone</v-icon>
                      </v-btn>
                    </a>
                  </v-flex>
                </v-row>
              </v-flex>
              <v-flex pt-1>
                <SimpleTextInput
                  v-if="destinationInfoActive()"
                  v-model="bookingForm.booking.destination_info.notes"
                  label="Notes"
                  :maxlength="300"
                />
              </v-flex>
              <v-flex shrink pt-1>
                <v-btn
                  v-if="destinationInfoActive()"
                  class="small-fab-phone"
                  icon
                  flat="flat"
                  @click="bookingForm.booking.destination_info.active = false"
                >
                  <v-icon>visibility_off</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
            <v-layout px-1 pr-2 py-2 row wrap justify-end style="width: 100%;">
              <v-btn @click="addVia()" small flat class="text-none">+ Via</v-btn>
            </v-layout>
            <v-flex px-2>
              <!-- <v-divider ></v-divider> -->
              <v-layout row>
                <v-divider style="margin-left: 12px; margin-top: 2px; margin-bottom: 5px;"></v-divider>
              </v-layout>
            </v-flex>
            <v-flex>
              <VehicleRequirementsInput :bookingForm="bookingForm" />
            </v-flex>
            <v-flex>
              <PassengerFindDetails :bookingForm="bookingForm" />
            </v-flex>
            <v-flex>
              <BookingDispatchInput :bookingForm="bookingForm" />
            </v-flex>
            <v-flex pb-1 px-2>
              <v-layout row>
                <v-divider style="margin-left: 12px; margin-top: 2px; margin-bottom: 5px;"></v-divider>
              </v-layout>
            </v-flex>
            <v-flex>
              <PaymentInput :bookingForm="bookingForm" @updateFinalCosts="updateFinalCosts" />
            </v-flex>
            <v-flex>
              <UserNotes @updateNotes="updateNotes" :bookingForm="bookingForm" />
            </v-flex>
          </v-flex>
          <BookRideOptions
            @update="bookingForm.updateRide(updatedBooking)"
            @book="bookingForm.bookRide(madeBooking)"
            @backdate="bookingForm.backdateRide(madeBooking)"
            @cancel="function(params){bookingForm.cancelRide(cancelledBooking, params)}"
            @change="showChangeUser"
            :backdate="backdate"
            :updateMode="updateMode"
            :bookingForm="bookingForm"
          />
          <v-layout style="width: 100%" align-end></v-layout>
        </v-layout>
      </v-flex>
      <v-flex v-if="bookingForm != null && bookingForm.booking != null" px-3 pb-2 xs12 md12 lg4 xl4>
        <OverwatchMap
          :enableDragToUpdate="true"
          ref="bookingMap"
          :showStateSummary="false"
          style="height: 600px;"
          @placechanged="locationChanged"
        />
        <v-col style="padding: 0px !important;">
          <v-row row pt-3>
            <v-checkbox
              small
              class="text-none"
              v-if="bookingForm.booking.driver_trace != null"
              @change="showDriverTrace"
              label="Show driver route"
              hide-details
              :disabled="!enableShowDriverTrace"
              v-model="showingDriverTrace"
            ></v-checkbox>
            <p>&nbsp;&nbsp;</p>
            <v-checkbox
              small
              class="text-none"
              v-if="bookingForm.booking.route.route_geometry != null"
              @change="showBookingRoute"
              label="Show suggested route"
              hide-details
            ></v-checkbox>
          </v-row>
          <v-flex pt-2 v-if="updateMode == true">
            <BookingActions :bookingForm="bookingForm" :updateMode="updateMode" />
          </v-flex>
          <v-flex
            mt-3
            pt-1
            v-if="getInformationResponse != null && getInformationResponse.taxis != null && !backdate"
            class="rounded-container"
            style="padding: 4px;"
          >
            <TaxiList
              v-if="taxiListMode == 'ride_types'"
              style="width: 100%;"
              :taxis="getInformationResponse.taxis"
              :rideTypes="bookingForm.rideTypes"
              :bookings="getInformationResponse.jobs"
              :rideTypeEtas="getInformationResponse.ride_type_eta"
            ></TaxiList>
            <div>
              <ZoneList
                v-if="taxiListMode == 'zones'"
                :rideTypes="bookingForm.rideTypes"
                :taxis="getInformationResponse.taxis"
                :rideTypeEtas="getInformationResponse.ride_type_eta"
                :bookings="getInformationResponse.jobs"
                :zones="zones"
              ></ZoneList>
            </div>
          </v-flex>
          <v-flex
            pt-1
            v-if="getInformationResponse != null && getInformationResponse.taxis != null && !backdate"
          >
            <v-btn
              x-small
              color="blue"
              class="text-none"
              dark
              @click="function() {taxiListMode == 'zones' ? (taxiListMode = 'ride_types') : (taxiListMode = 'zones')}"
            >{{taxiListMode != 'zones' ? 'Zones' : 'Ride Types'}}</v-btn>
          </v-flex>
        </v-col>
      </v-flex>
      <v-flex px-3 pt-1 xs12 md12 lg3 xl3 class="rounded-container">
        <v-layout v-if="updateMode == false" column>
          <h5 v-if="bookingForm.user.active_bookings.length > 0">Active Trips</h5>
          <UserActiveBookings
            v-if="bookingForm.user.active_bookings.length > 0"
            :bookingForm="bookingForm"
          />
          <h5 v-if="bookingForm.user.booked_bookings.length > 0">Booked Trips</h5>
          <UserBookedBookings
            v-if="bookingForm.user.booked_bookings.length > 0"
            :bookingForm="bookingForm"
            :rebook="rebook"
          />
          <h5 v-if="bookingForm.user.recent_bookings.length > 0">Recent Trips</h5>
          <UserRecentBookings
            v-if="bookingForm.user.recent_bookings.length > 0"
            :bookingForm="bookingForm"
            :rebook="rebook"
          />
        </v-layout>
        <v-layout v-if="updateMode == true" column pt-2>
          <h5>Booking Timeline</h5>
          <Timeline :booking="bookingForm.booking" />
          <h5 style="padding-top: 12px;">Payment</h5>
          <SumupTransaction
            v-if="bookingForm.booking.payment_type == 'card_in_cab'"
            :bookingForm="bookingForm"
          ></SumupTransaction>
          <StripeTransaction
            v-if="bookingForm.booking.payment_type == 'card'"
            :bookingForm="bookingForm"
          ></StripeTransaction>
          <v-flex pt-2>
            <SendReceipt :bookingForm="bookingForm" />
          </v-flex>
        </v-layout>
        <v-layout v-if="updateMode == true">
          <v-flex class="rounded-container" pt-2>
            <BookingReviewSummary :bookingForm="bookingForm" />
          </v-flex>
        </v-layout>
      </v-flex>
      <v-dialog persistent v-model="changeUserDialog" :width="450">
        <v-card v-if="bookingForm.booking != null">
          <v-card-title primary-title class="headline grey lighten-1">
            <v-layout align-center justify-center>
              <span
                class="title font-weight-light white--text"
                style="line-height: 18pt !important;"
              >
                Change User for booking:
                <b>{{bookingForm.booking.id}}</b>
              </span>
            </v-layout>
          </v-card-title>
          <v-flex px-3 py-2>
            <v-flex xs12>
              <v-autocomplete
                v-model="customer"
                :items="customers"
                :loading="loading"
                :search-input.sync="search"
                item-text="descriptor"
                label="Customer Search*"
                hide-no-data
                hide-selected
                no-filter
                return-object
                @change="customerSelected"
                required
              ></v-autocomplete>
            </v-flex>
          </v-flex>
          <v-card-actions>
            <v-layout row justify-end>
              <v-btn color="red darken-1" flat @click="changeUserDialog = false">Cancel</v-btn>
              <v-btn color="green darken-1" flat @click="changeUser">Update</v-btn>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </form>
</template>

<script>
import { Overwatch } from "@/components/util/Overwatch.js";

import TaxiList from "@/components/overwatch/TaxiList.vue";
import ZoneList from "@/components/overwatch/ZoneList.vue";

import UserActiveBookings from "@/components/overwatch/UserActiveBookings.vue";
import UserBookedBookings from "@/components/overwatch/UserBookedBookings.vue";
import UserRecentBookings from "@/components/overwatch/UserRecentBookings.vue";

import Timeline from "@/components/booking/Timeline.vue";

import BookingLocationInput from "@/components/widget/input/BookingLocationInput.vue";
import SimpleTextInput from "@/components/widget/input/SimpleTextInput.vue";
import SelectableInput from "@/components/widget/input/SelectableInput.vue";
import BookingDateTimeInput from "@/components/widget/input/BookingDateTimeInput.vue";

import SimpleCard from "@/components/widget/SimpleCard.vue";

import BookingReviewSummary from "@/components/rating/BookingReviewSummary.vue";

import SendReceipt from "@/components/booking/SendReceipt.vue";

import BookingActions from "@/components/widget/input/BookingActions.vue";
import BookRideOptions from "@/components/widget/input/BookRideOptions.vue";
import BusinessCustomerDetailsInput from "@/components/widget/input/BusinessCustomerDetailsInput.vue";
import VehicleRequirementsInput from "@/components/widget/input/VehicleRequirementsInput.vue";
import PassengerFindDetails from "@/components/widget/input/PassengerFindDetails.vue";
import PaymentInput from "@/components/widget/input/PaymentInput.vue";
import BookingDispatchInput from "@/components/widget/input/BookingDispatchInput.vue";
import CardInput from "@/components/widget/input/CardInput.vue";
import PromocodeInput from "@/components/widget/input/PromocodeInput.vue";

import SumupTransaction from "@/components/booking/SumupTransaction.vue";
import StripeTransaction from "@/components/booking/StripeTransaction.vue";

import CustomerSearchInput from "@/components/widget/input/CustomerSearchInput.vue";
import UserNotes from "@/components/widget/input/UserNotes.vue";

import OverwatchMap from "@/components/overwatch/OverwatchMap.vue";

import BookTripETARoute from "@/components/widget/input/BookTripETARoute.vue";

import qs from "qs";
import axios from "axios";
axios.defaults.withCredentials = true;

import { replaceStart } from "@/components/util/PhoneNumbers.js";

export default {
  name: "LargeBookForm",
  model: {
    prop: "content",
    event: "input",
  },
  components: {
    BookingDispatchInput,
    BookingLocationInput,
    SimpleTextInput,
    BookingActions,
    SelectableInput,
    BookingDateTimeInput,
    BusinessCustomerDetailsInput,
    VehicleRequirementsInput,
    PassengerFindDetails,
    PaymentInput,
    CustomerSearchInput,
    UserNotes,
    OverwatchMap,
    BookTripETARoute,
    CardInput,
    PromocodeInput,
    UserActiveBookings,
    UserRecentBookings,
    BookRideOptions,
    Timeline,
    SumupTransaction,
    StripeTransaction,
    SendReceipt,
    BookingReviewSummary,
    SimpleCard,
    UserBookedBookings,
    TaxiList,
    ZoneList,
  },
  props: {
    taxis: Array,
    bookings: Array,
    rideTypes: Array,
    setSelectedTaxi: Function,
    selectedTaxi: Number,
    expand: Function,
    bookingForm: Object,
    updateMode: {
      type: Boolean,
      default: false,
    },
    backdate: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    enableShowDriverTrace: function () {
      return !(
        this.bookingForm.booking.state == "accepted" ||
        this.bookingForm.booking.state == "pob"
      );
    },
    userIsBusiness: function () {
      return this.bookingForm.user.business == true;
    },
    bookingIsCompletedOrCancelled() {
      return (
        this.bookingForm.booking.state == "completed" ||
        this.bookingForm.booking.state == "cancelled"
      );
    },
  },
  watch: {
    search(val) {
      console.log(val);

      if (val == null) return;
      if (val.length <= 1) return;

      var url = `${this.$store.state.apiUrl}/customer/search?query=${val}`;

      var searchCompleted = this.searchCompleted;

      axios({
        url: url,
        method: "GET",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
        .then(function (res) {
          searchCompleted(res.data);
        })
        .catch(function (err) {
          console.error(err);
          this.loading = false;
        });
    },
  },
  beforeDestroy: function () {
    clearTimeout(this.getDriverLocationTimer);
    clearTimeout(this.getInformationTimer);

    this.getInformationTimer = null;
  },
  mounted: function () {
    var centerToBooking = this.centerToBooking;
    setTimeout(centerToBooking, 2000);

    var vm = this;

    this.getDriverLocationTimer = setInterval(function () {
      vm.getDriverLocation();
    }, 5000);

    if (
      this.bookingForm.booking.state == null ||
      (this.bookingForm.booking.state != "completed" &&
        this.bookingForm.booking.state != "cancelled")
    ) {
      this.getInformationTimer = setTimeout(this.getInformation, 2000);
    }

    this.getZones();
  },
  data() {
    return {
      changeUserDialog: false,
      customers: [],
      customer: {},
      search: null,
      bookingReturn: false,
      loading: false,
      showingDriverTrace: false,
      getDriverLocationTimer: null,
      getInformationTimer: null,
      getInformationResponse: {
        taxis: [],
        bookings: [],
        ride_type_etas: [],
      },
      taxiListMode: "ride_types",
      zones: [],
    };
  },
  methods: {
    getDriverLocation: async function () {
      if (
        this.bookingForm.booking.state == null ||
        this.bookingIsCompletedOrCancelled
      ) {
        clearInterval(this.getDriverLocationTimer);
        return;
      }

      try {
        let response = await axios.get(
          `${this.$store.state.apiUrl}/booking/getDriverTraceForLiveDisplay?id=${this.bookingForm.booking.id}`,
          {},
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        );

        this.bookingForm.booking.driver_trace = response.data.driver_trace;

        this.showDriverTrace(false);
        this.showDriverTrace(true, false);
      } catch (error) {
        console.log(error);
      }
    },
    formatNumber: function (number) {
      return replaceStart(number);
    },
    showChangeUser: function () {
      console.log("Show change user dialog");
      this.changeUserDialog = true;
    },
    changeUser: async function () {
      this.changeUserDialog = false;

      try {
        let response = await axios.post(
          `${this.$store.state.apiUrl}/booking/changeUser?booking_id=${this.bookingForm.booking.id}&user_id=${this.customer.id}`,
          {},
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        );

        if (response.data.error == "no_error") {
          alert("Booking User updated");
          this.bookingForm.getCustomer(this.customer.contact_number);
        } else {
          alert(response.data.error);
        }
      } catch (error) {
        console.log(error);
        alert("Unknown error");
      }
    },
    customerSelected: function (customer) {
      console.log("Changed " + JSON.stringify(customer));
    },
    searchCompleted: function (data) {
      this.customers = data.customers;

      this.customers.forEach(function (c) {
        c.descriptor = c.name + " " + c.contact_number;
      });

      this.loading = false;
    },
    showDriverTrace: function (selected, recenter) {
      if (selected) {
        var driverTrace = this.bookingForm.booking.driver_trace;

        console.log(driverTrace);

        this.$refs.bookingMap.showDriverTrace(
          driverTrace,
          this.bookingForm.booking,
          recenter,
          !this.enableShowDriverTrace
        );
      } else {
        console.log("hiding driver trace");
        this.$refs.bookingMap.hideDriverTrace();
      }
    },
    showBookingRoute: function (selected) {
      if (selected) {
        var geometry = this.bookingForm.booking.route.route_geometry;

        console.log(geometry);

        this.$refs.bookingMap.showBookingRoute(geometry);
      } else {
        this.$refs.bookingMap.hideBookingRouteTrace();
      }
    },
    updateFinalCosts: function () {
      console.log("Updating final costs");
      this.bookingForm.updateFinalCosts();
    },
    updateNotes: function () {
      console.log("Updating notes");
      this.bookingForm.updateNotes();
    },
    cancelledBooking: function () {
      this.$emit("cancelledBooking", null);
    },
    madeBooking: function () {
      this.$emit("madeBooking", null);
    },
    updatedBooking: function () {
      this.$emit("updatedBooking", null);
    },
    swapPickupAndDestination: function () {
      this.bookingForm.swapPickupAndDestination();
      this.centerToBooking();
      this.$emit("locationsChanged", "");
    },
    activatePickupInfo: function () {
      this.bookingForm.booking.pickup_info.active = true;
    },
    pickupInfoActive: function () {
      return (
        this.bookingForm.booking.pickup_info != null &&
        this.bookingForm.booking.pickup_info.active == true
      );
    },
    activateDestinationInfo: function () {
      this.bookingForm.booking.destination_info.active = true;
    },
    destinationInfoActive: function () {
      return (
        this.bookingForm.booking.destination_info != null &&
        this.bookingForm.booking.destination_info.active == true
      );
    },
    centerToBooking: function () {
      try {
        this.$refs.bookingMap.zoomToMakingBooking(this.bookingForm.booking);
      } catch (e) {
        console.log(e);
      }
    },
    addVia: function () {
      this.bookingForm.addVia();
    },
    getCostEstimate: function (loc) {
      this.bookingForm.getCostEstimate();
    },
    pickupUpdated: function (loc) {
      this.bookingForm.booking.pickup_location = loc;
      this.getCostEstimate();

      this.centerToBooking();
      this.$emit("locationsChanged", "");

      this.getCostEstimate();
    },
    destinationUpdated: function (loc) {
      this.bookingForm.booking.destinations[0] = loc;
      this.getCostEstimate();

      this.centerToBooking();
      this.$emit("locationsChanged", "");

      this.getCostEstimate();
    },
    locationChanged: function (loc) {
      this.getCostEstimate();
    },
    viaUpdated: function (loc) {
      this.centerToBooking();
      this.$emit("locationsChanged", "");

      this.getCostEstimate();
    },
    viaActive: function (via) {
      return via != null && via.active != null && via.active == true;
    },
    removeVia: function (index) {
      this.bookingForm.booking.destinations.splice(index, 1);
      this.bookingForm.booking.via_info.splice(index - 1, 1);

      this.getCostEstimate();

      this.centerToBooking();
      this.$emit("locationsChanged", "");
    },
    activateViaInfo: function (index) {
      this.bookingForm.booking.via_info[index - 1].active = true;
      this.$forceUpdate();
    },
    rebook(booking) {
      this.bookingForm.rebook(booking);

      this.centerToBooking();
      this.$emit("locationsChanged", "");
    },
    getInformation: async function () {
      try {
        var url = `${this.$store.state.apiUrl}/overwatch/getInformation?hoursToShow=0&historyToReturn=0`;

        let response = await axios.get(url, {
          params: {},
        });

        // console.log(response.data);

        this.lastUpdateTime = new Date();

        this.getInformationResponse = response.data;

        if (this.getInformationTimer != null) {
          setTimeout(this.getInformation.bind(this), 3000);
        }
      } catch (error) {
        if (this.getInformationTimer != null) {
          setTimeout(this.getInformation.bind(this), 3000);
        }
        console.log("Failed to get information " + error);
      }
    },
    getZones: async function () {
      try {
        var url = `${this.$store.state.apiUrl}/zones/all`;

        let response = await axios.get(url, {
          params: {},
        });

        this.zones = response.data.zones;
        this.$store.state.use_zone_based_dispatch =
          response.data.use_zone_based_dispatch;

        console.log("got zones");
      } catch (error) {
        this.loading = false;
        console.log("Failed to get zones " + error);
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.small-table-text ul {
  list-style: none;
  padding-left: 0px !important;
}

.small-table-text td {
  font-size: 11px !important;
}

.small-table-text tr:nth-child(even) {
  background-color: #f7f7f7;
}

.taxi-list-header {
  color: #10425a;
}

.small-button {
  font-size: 12px !important;
}

.disabled-panel {
  pointer-events: none;
}

// .small-book-form .v-text-field {
//   padding-top: 4px !important;
//   margin-top: 4px !important;
// }

.rounded-container {
  background-color: white;
  border-radius: 8px;
}

.visibility-toggle {
  margin-top: -2px;
}
</style>
